import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
  ATTR_USER_AGENT_ORIGINAL,
} from '@opentelemetry/semantic-conventions';
import { initResource } from './resource';
import { setupTracing } from './instrumentation';
import { getBrowserDetails } from '../../common/status';

interface OtelConfig {
  env: string;
  version: string;
  name: string;
}

export function InitOtel(params: OtelConfig) {
  const browserInfo = getBrowserDetails();
  const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
  initResource({
    [ATTR_SERVICE_NAME]: params.name,
    [ATTR_SERVICE_VERSION]: params.version,
    [ATTR_USER_AGENT_ORIGINAL]: userAgent,
    // `deployment.environment` populates the indexed `deployment_environment`
    // label in Loki/Tempo (so you can filter by env). `env` is kept for
    // backward-compat with existing queries that read it from the body.
    'deployment.environment': params.env,
    env: params.env,
    os: browserInfo.OSName,
    browser: browserInfo.browserName,
    browserVersion: browserInfo.fullVersion,
  });
  setupTracing();
}
